import { Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDataSimulator } from '../../helpers/dataSimulator';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import { SearchOutlined } from '@ant-design/icons';
import CountriesAndPaymentMethodsHeader from '../../components/CountriesAndPaymentMethods/CountriesAndPaymentMethodsHeader/CountriesAndPaymentMethodsHeader';
import { getCountryAndPaymMethodColumn } from '../../helpers/countryAndPaymMethodColumn';
import './CountriesAndPaymentMethods.scss';
import { useConfigurationContext } from '../../store/configurationContext';
import { StyledPagination } from '../../components/table.style';

const CountriesAndPaymentMethods = () => {
	const { t } = useTranslation();
	const [loading, setLoading] = useState<boolean>(false);
	const [countryAndPaymMethods, setCountryAndPaymMethods] = useState([]);
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [pagesize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState<string>('');
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';

	useEffect(() => {
		setLoading(true);

		let url = API_ENDPOINTS.countryAndPaymMethod;
		let params = new URLSearchParams();
		params.set('limit', pagesize.toString());
		params.set('offset', '0');

		if (searchTerm && searchTerm !== '') {
			params.set('search', searchTerm);
		}

		if (sortBy && sortBy !== '') {
			params.set('sort', sortBy);
		}

		Promise.all([
			getDataSimulator(url).catch((_: any) => setLoading(false)),
			getDataSimulator(API_ENDPOINTS.countryAndPaymMethod).catch((_: any) => setLoading(false)),
		]).then(([countryAndPaymMethodData]: any) => {
			setCountryAndPaymMethods(countryAndPaymMethodData);
			setLoading(false);
		});
	}, [pagesize, setLoading, searchTerm, sortBy]);

	return (
		<div>
			<CountriesAndPaymentMethodsHeader />
			<div className='max-w-[1440px] mx-auto  px-5 py-5 bg-white'>
				<div className='mb-10 flex items-center justify-end w-full'>
					<div className='flex items-center'>
						<Input
							className='border-none h-10 bg-[#F5F5F5] search-input'
							disabled={loading}
							placeholder={t<string>('searchInCountriesAndPaymTable')}
							value={searchTerm}
							onChange={(e) => {
								setSearchTerm(e.target.value);
							}}
							size='large'
							prefix={<SearchOutlined className='mr-2' />}
						/>
					</div>
				</div>
				<StyledPagination bgColor={themeColor} color={secondary_color}>
					<Table
						columns={getCountryAndPaymMethodColumn(t, sortBy, setSortBy)}
						dataSource={countryAndPaymMethods}
						loading={loading}
						pagination={{ pageSize: pagesize }}
						tableLayout='auto'
					/>
				</StyledPagination>
			</div>
		</div>
	);
};

export default CountriesAndPaymentMethods;
